import { LitElement, html } from "lit-element";
import { connect } from "pwa-helpers/connect-mixin.js";
import { installRouter } from "pwa-helpers/router.js";
import { installOfflineWatcher } from 'pwa-helpers/network.js';
import { store } from "../inspx-store.js";
import "./inspx-new-inspections.js";
import "./inspx-local-inspections.js";
import "./inspx-completed-inspections.js";
import "./inspx-inspection.js";
import "./inspx-remote-inspection.js";
import "./inspx-inspection-navbar.js";
import "./inspx-login-box.js";
import {
	navigate,
	openLoginBox,
	initDb,
	goOnLine,
	goOffLine,
	parseJwt
} from "../actions/app.js";
import "./drawing/inspx-drawing-tool.js";

import { fetchNewInspections } from "../actions/new-inspections.js";
import { fetchCompletedInspections } from "../actions/completed-inspections.js";
import { loadLocalInspections } from "../actions/local-inspections.js";
import { loadInspection } from "../actions/inspection.js";
import { colorTheme } from "../styles/color-theme.js";
import { updateSw } from "../lib/helpers.js";

const urlParams = new URLSearchParams(window.location.search);
let t = urlParams.get('t');
let openedFromCore = false;
if (t) {
	let token = parseJwt(t);
	localStorage.setItem('username', token.name);
	localStorage.setItem("token", t);
	openedFromCore = true;
}

if (window.SharedWorker) {
	window.sync = new SharedWorker("/build/rollup/sharedSyncWorker.js", "inspx-sync").port;

	window.sync.start();

} else
	window.sync = new Worker("/build/rollup/dedicatedSyncWorker.js");


class inspxApp extends connect(store)(LitElement) {
	render() {
		return html`
        ${colorTheme}
        <style>
            :host {
                display: block;
                height: 100vh;
                width: 100%;
                background-color: var(--primary-color-variant2);
            }
        
            *,
            *:before,
            *:after {
                box-sizing: border-box;
            }
        
           
        
            .header {
                box-shadow: 0px 1px 2px #464646;
                color: white;
                position: -webkit-sticky; /* Safari */
                position: sticky;
                top: 0;
                z-index: 1000;
            }
        
            .content {
  background-color: var(--primary-color-variant2);
            }

            
        
        </style>
        
        <div class="wrapper">
            <header class="header">
                <inspx-inspection-navbar .headerTitle="${this.headerTitle}" .swVersion="${this.swVersion}" .online="${this.online}"></inspx-inspection-navbar>
            </header>
        
            <div id='ct' class="content">
                ${this.renderPage(this.page)}
            </div>
        </div>
        
        <inspx-login-box open="${this.openLoginBox}" .error="${this.loginError}"></inspx-login-box>`;
	}

	goTo(p) {
		store.dispatch(navigate(p));
	}

	renderPage(page) {
		switch (page) {
			case "new-inspections":
				return html`
                    <inspx-new-inspections></inspx-new-inspections>`;
			case "remote-inspection":
				return html`
                    <inspx-remote-inspection></inspx-remote-inspection>`;
			case "inspection":
				return html`
                    <inspx-inspection></inspx-inspection>`;
			case "active-inspections":
				return html`
                    <inspx-local-inspections></inspx-local-inspections>`;
			case "completed-inspections":
				return html`
                    <inspx-completed-inspections></inspx-completed-inspections>`;
		}
	}

	static get properties() {
		return {
			headerTitle: { type: String },
			page: { type: String },
			inspId: { type: String },
			openLoginBox: { type: Boolean },
			loginError: { type: String },
			online: { type: Boolean },
			swVersion: { type: String },
		};
	}

	constructor() {
		super();

		this.openedFromCore = openedFromCore;

		this.focus({ preventScroll: true });
		window.INSP.APP = this;

		store.dispatch(initDb(localStorage.username));

		this.addEventListener("beforeinstallprompt", e => {
			// Prevent Chrome 67 and earlier from automatically showing the prompt
			e.preventDefault();
			e.prompt();
		});
	}

	firstUpdated() {

		installRouter(location => this._locationChanged(location));
		installOfflineWatcher((offline) => {
			if (offline) {
				store.dispatch(goOffLine());
			} else {
				store.dispatch(goOnLine());
				if (!this.openLoginBox) {
					if (this.page == "new-inspections") {
						store.dispatch(fetchNewInspections());
					} else if (this.page == "completed-inspections") {
						store.dispatch(fetchCompletedInspections());
					}
				}
			}
			window.sync.postMessage({
				name: "offlineWatcher",
				value: offline
			});
		});
		this.__setupSyncWorker();
		this.openDrawingTool = function () {
			var dt = document.createElement("inspx-drawing-tool");
			document.body.appendChild(dt);
		};
	}

	_locationChanged(location) {
		store.dispatch(navigate(location.pathname, true));
	}

	stateChanged(state) {
		this.page = state.app.route.page;
		this.inspId = state.app.route.id;
		this.openLoginBox = state.app.openLoginBox;
		this.loginError = state.app.loginError;
		this.online = state.app.online;

		if (state.inspection && state.inspection.current) {
			this.coverId = state.inspection.current.cover_image_id;
			this.headerTitle = state.inspection.current.name + " - " + state.inspection.current.type.name;
		} else {
			this.headerTitle = "Inspecties";
		}
		this.state = state;
		this.__informSyncWorker(state);
	}

	__setupSyncWorker() {
		const onSyncWorkerMessage = e => {
			switch (e.data.name) {
				case "ready":
					this.__informSyncWorker(this.state);
					break;

				case "login":
					store.dispatch(openLoginBox());
					break;

				case "sync":
					this._handleSync(e.data);
					break;

				case "refreshState":
					this._refreshStateMsg(e.data);
					break;

				case "update-sw":
					updateSw(e.data.lud);
					break;

				case "refreshToken":
					store.dispatch(openLoginBox());
					break;

				case 'sync-worker-version':
					this.swVersion = e.data.v;
					break;

				default:
					break;
			}
		};
		window.sync.addEventListener("message", onSyncWorkerMessage);
	}

	_refreshStateMsg(data) {
		if (this.page === "active-inspections") {
			store.dispatch(loadLocalInspections());
		} else if (this.page === "inspection" && this.inspId == data.inspKey) {
			this.reloadInspection();
		}
	}

	_handleSync(data) {
		switch (this.page) {
			case "new-inspections":
				store.dispatch(fetchNewInspections());
				break;

			case "completed-inspections":
				store.dispatch(fetchCompletedInspections());
				break;

			case "active-inspections":
				store.dispatch(loadLocalInspections());
				break;

			case "inspection":
				if (this.inspId == data.inspKey)
					if (data.command == "lmd") {
						//   store.dispatch(updateLmd());
					} else if (data.command == "inspectionDeleted") {
						store.dispatch(navigate("/active-inspections"));
					} else if (data.command == "inspectionCopied_ready") {
						store.dispatch(navigate("/inspection/" + data.newInspKey));
					} else {
						this.reloadInspection();
					}

				break;

			default:
				break;
		}
	}

	reloadInspection() {
		store.dispatch(loadInspection());
	}

	__informSyncWorker(state) {
		const connectionData = {
			server: window.INSP.config.apiUrl,
			token: localStorage.token,
			dbName: state.app.dbName,
			lud: state.app.lud,
		};
		if (JSON.stringify(connectionData) != this.prevCDJson)
			window.sync.postMessage({
				name: "connectionData",
				value: connectionData
			});
		this.previousConnectionData = connectionData;
		this.prevCDJson = JSON.stringify(connectionData);
	}
}

window.customElements.define("inspx-app", inspxApp);
